import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translations.json";
import de from "./locales/de/translations.json";

// ✅ Load saved language early (before initialization)
const savedLang = localStorage.getItem("selectedLanguage") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    lng: savedLang, // use saved language directly
    fallbackLng: "en",
    supportedLngs: ["en", "de"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // avoid React suspense flicker
    },
  });

// ✅ Optional safeguard: if route starts with /de, make sure lang is set
const currentPath = window.location.pathname;
if (currentPath.startsWith("/de") && savedLang !== "de") {
  i18n.changeLanguage("de");
  localStorage.setItem("selectedLanguage", "de");
}

export default i18n;
